
$('.js-header-nav').each(function () {
    let $nav = $(this);
    let $navs = $('.js-header-nav-list-item', $nav);
    let $menus = $('.js-header-nav-menu', $nav);
    let $menusWrapper = $('.js-header-nav-menu-wrapper', $nav);

    $navs.each(function (i, el) {
        if (App.H.hasClass('mobile')) {
            $(el).on('click', function (e) {
                if ($menus.eq(i).length ) {
                    e.preventDefault();

                    if (!$menus.eq(i).hasClass('_active')) {
                        $menus
                            .removeClass('_active')
                            .eq(i)
                            .addClass('_active');
                        if( $menus.eq(i).length  ){
                            $menusWrapper.addClass('_active');
                        } else {
                            $menusWrapper.removeClass('_active');
                        }
                    } else {
                        $menus.removeClass('_active');
                        $menusWrapper.removeClass('_active');
                    }
                }
            });
        } else {
            $(el).on('mouseenter', function () {
                $menus
                    .removeClass('_active')
                    .eq(i)
                    .addClass('_active');
                if( $menus.eq(i).length  ){
                    $menusWrapper.addClass('_active');
                } else {
                    $menusWrapper.removeClass('_active');
                }
            });
        }
    });

    $nav.on('mouseleave', function () {
        $menus.removeClass('_active');
        $menusWrapper.removeClass('_active');
    });
});

$('.js-footer-nav').each(function () {
    const $root = $(this);
    const $toggler = $('[data-nav-toggler]', this);
    const $content = $('[data-nav-content]', this);

    $toggler.on('click', function () {
        $content.slideToggle();
        $root.toggleClass('__opened');
    });
});
